import {GET_GROUP_DETAIL_POSTS_START} from "../../types";

export const group_detail_posts = (payload) => ({
    type: GET_GROUP_DETAIL_POSTS_START,
    payload,
});
